import { ArrowLinksSVG } from '@snack-uikit/icons';
import { Typography } from '@snack-uikit/typography';

import { LinkWrapper } from '@/components/static';

import s from './styles.module.scss';
import { UseFullPagesConfigItem } from './utils';

export function UsefulLink({ label, link }: UseFullPagesConfigItem) {
  return (
    <div className={s.link_wrapper_container}>
      <LinkWrapper textWrapper={Typography.SansBodyL} link={link}>
        {label}
      </LinkWrapper>
      <ArrowLinksSVG className={s.not_found_title_text} />
    </div>
  );
}
